import React, { useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'
import { useLocation } from 'react-router-dom'
import { AbroadGoldenIcon } from '../components'
import { InviteDetailsContext } from '../utils/contexts'

const QuestEntryModal = ({ mode, firstName, show, onClose }) => {
  const location = useLocation()
  const { inviteLinkDetails } = useContext(InviteDetailsContext)
  const query = new URLSearchParams(location?.search)
  const hasInviteToken = query.get('mode') === 'invite'
  const hasOnlyInParam =
    (query.get('e') || query.get('c')) &&
    !query.get('mode') &&
    !query.get('token') &&
    !query.get('fname') &&
    !query.get('lname') &&
    !query.get('email')

  const isSignup = hasInviteToken || hasOnlyInParam
  const isLogin = !isSignup
  const modalDescription = (
    <>
      <p>Hi{firstName ? ` ${firstName}` : ''},</p>
      <div
        dangerouslySetInnerHTML={{
          __html: `<div>${inviteLinkDetails?.welcomeLetter}</div>`,
        }}
      />
    </>
  )

  return (
    <Modal
      show={show}
      size='lg'
      onHide={onClose}
      centered
      dialogClassName='quest-modal'
      backdropClassName='opacity-25'>
      <>
        <div className='p-24px'>
          <Modal.Header className='border-0  p-0 d-flex justify-content-center'>
            <div>
              <AbroadGoldenIcon isQuestEntry={true} />
              <h2 className='mb-24px s14 mt-24px'>
                {inviteLinkDetails?.title
                  ? inviteLinkDetails?.title
                  : 'Welcome to True Prosperity in Bhutan'}
              </h2>
            </div>
          </Modal.Header>
          <Modal.Body className='p-0 bg-gray-300 p-3 rounded'>
            {modalDescription}
          </Modal.Body>
          <Modal.Footer className='border-0 d-flex justify-content-center mt-24px'>
            <Button
              variant='saffron'
              size='md'
              className='text-uppercase border-radius-normal text-white hover:text-white m-0'
              onClick={onClose}>
              {isSignup ? 'Sign Up' : isLogin && 'Login'}
            </Button>
          </Modal.Footer>
        </div>
      </>
    </Modal>
  )
}

export default QuestEntryModal
